export const RequestTypes = {
  UPDATE: 'PropertiesUpdate',
};

/**
 * Resolve the drawer's initial Category value.
 *
 * `categoryOptions` only holds ENABLED categories, so a condition assigned to a
 * later-disabled category (or when the option list hasn't loaded) would fall
 * through to `null` and submit an explicit clear. Fall back to the full category
 * list so an assigned-but-disabled category still displays and its id is preserved.
 *
 * @returns {{ value: string, label: string } | null}
 */
export const resolveInitialCategory = ({ categoryOptions, categories, conditionCategoryId }) => {
  if (!conditionCategoryId) {
    return null;
  }

  const enabledOption = categoryOptions.find(({ value }) => value === conditionCategoryId);

  if (enabledOption) {
    return enabledOption;
  }

  const assigned = categories.find(category => category.id === conditionCategoryId);

  return assigned ? { value: assigned.id, label: assigned.name } : null;
};
